import { gql } from 'graphql-tag'

export const vitrineProductFragment = gql`
  fragment VitrineProductFragment on VitrineProduct {
    id
    name
    type
    station {
      id
      name
    }
    wastePercent
  }
`

export const availableVitrineProductsQuery = gql`
  query AvailableVitrineProducts($stationId: ID!) {
    availableVitrineProducts(stationId: $stationId) {
      ...VitrineProductFragment
    }
  }
  ${vitrineProductFragment}
`

export const createVitrineProduct = gql`
  mutation CreateVitrineProduct($stationId: ID, $vitrineProduct: CreateVitrineProductInput!) {
    createVitrineProduct(stationId: $stationId, vitrineProduct: $vitrineProduct) {
      ...VitrineProductFragment
    }
  }
  ${vitrineProductFragment}
`

export const updateVitrineProduct = gql`
  mutation UpdateVitrineProduct($vitrineProductId: ID!, $vitrineProduct: UpdateVitrineProductInput!) {
    updateVitrineProduct(vitrineProductId: $vitrineProductId, vitrineProduct: $vitrineProduct) {
      ...VitrineProductFragment
    }
  }
  ${vitrineProductFragment}
`

export const deleteVitrineProduct = gql`
  mutation DeleteVitrineProduct($id: ID!) {
    deleteVitrineProduct(vitrineProductId: $id)
  }
`

const vitrineProductTimeSlotWeightFragment = gql`
  fragment VitrineProductTimeSlotWeightFragment on VitrineProductTimeslotWeight {
    timeslot
    weight
    productType
    weekday
  }
`

const vitrineProductWithWeightFragment = gql`
  fragment VitrineProductWithWeightFragment on VitrineProductWithWeight {
    id
    stationId
    name
    weight
    timeslot
    isPublic
  }
`

const vitrineProductWeightGroupFragment = gql`
  fragment VitrineProductWeightGroupFragment on VitrineProductWeightGroup {
    timeslot
    weights {
      ...VitrineProductWithWeightFragment
    }
  }
  ${vitrineProductWithWeightFragment}
`

export const vitrineProductWeightsQuery = gql`
  query VitrineProductWeights($stationId: ID!) {
    saltyVitrineProductWeights: vitrineProductWeights(stationId: $stationId, productType: Salty) {
      ...VitrineProductWeightGroupFragment
    }
    sweetVitrineProductWeights: vitrineProductWeights(stationId: $stationId, productType: Sweet) {
      ...VitrineProductWeightGroupFragment
    }
  }
  ${vitrineProductWeightGroupFragment}
`

export const vitrineProductTimeslotWeightsQuery = gql`
  query VitrineProductWeights($stationId: ID!, $weekday: VitrineProductWeightWeekday!) {
    saltyVitrineProductTimeSlotWeights: vitrineProductTimeslotWeights(
      stationId: $stationId
      weekday: $weekday
      productType: Salty
    ) {
      ...VitrineProductTimeSlotWeightFragment
    }
    sweetVitrineProductTimeSlotWeights: vitrineProductTimeslotWeights(
      stationId: $stationId
      weekday: $weekday
      productType: Sweet
    ) {
      ...VitrineProductTimeSlotWeightFragment
    }
  }
  ${vitrineProductTimeSlotWeightFragment}
`

export const upsertVitrineProductWeight = gql`
  mutation UpsertVitrineProductWeight($stationId: ID!, $vitrineProductWeight: VitrineProductWeightInput) {
    upsertVitrineProductWeight(stationId: $stationId, vitrineProductWeight: $vitrineProductWeight) {
      timeslot
      weight
      vitrineProduct {
        ...VitrineProductFragment
      }
      station {
        id
        name
      }
    }
  }
  ${vitrineProductFragment}
`

export const upsertVitrineProductTimeSlotWeight = gql`
  mutation UpsertVitrineProductTimeSlotWeight(
    $stationId: ID!
    $vitrineProductTimeSlotWeight: VitrineProductTimeslotWeightInput
  ) {
    upsertVitrineProductTimeslotWeight(
      stationId: $stationId
      vitrineProductTimeslotWeight: $vitrineProductTimeSlotWeight
    ) {
      ...VitrineProductTimeSlotWeightFragment
    }
  }
  ${vitrineProductTimeSlotWeightFragment}
`

export const updateVitrineProductWastePercent = gql`
  mutation UpdateVitrineProductWastePercent($id: ID!, $stationId: ID!, $wastePercent: Float) {
    updateVitrineProductWastePercent(vitrineProductId: $id, stationId: $stationId, wastePercent: $wastePercent) {
      ...VitrineProductFragment
    }
  }
  ${vitrineProductFragment}
`
